import React, { useEffect, useState, useLayoutEffect } from 'react';
import {
	Container,
	Row,
	Col,
	Button,
	Table,
	Form,
	Figure,
	Tabs,
	Tab,
	Modal,
	InputGroup,
	Pagination,
} from "react-bootstrap";
import { 
	RiUploadLine ,
	RiDeleteBinLine,
	RiCloseLine,
	RiUpload2Line,
} from "react-icons/ri";
import Config from '../common/config.js';
import pushInput from '../common/PushInput.js';
import pushStat from '../common/PushStat.js';
import {CommonUI} from '../common/commonUI.js';


const PopupPushStatus = (opt) => {
	//Config.log("PopupSearchPushTarget opt-->");
	//Config.log(opt);

	const [userList, setUserList] = useState([]);
	const [pageItems, setPageItems] = useState([]);

	useEffect( () => {
		Config.log("refresh 1");
		reqList(1);
	}, []);


	const selfClose = function() {
		opt.close(false);
	}

	const changeStatus = function(st) {
		let msg = "";
		let msgs = "";
		let msgf = "";
		if(st == "P") {
			msg = "일시정지 하시겠습니까?";
			msgs = "일시정지 하였습니다.";
			msgf = "일시정지에 실패하였습니다.\n다시 시도해 주세요.";
		}
		else if(st == "E") {
			msg = "긴급종료 하시겠습니까?";
			msgs = "긴급종료 하였습니다.";
			msgf = "긴급종료에 실패하였습니다.\n다시 시도해 주세요.";
		}
		else if(st == "R") {
			msg = "일시정지를 해제하시겠습니까?";
			msgs = "일시정지 해제하였습니다.";
			msgf = "일시정지 해제에 실패하였습니다.\n다시 시도해 주세요.";
		}
		if(window.confirm(msg)) {
			Config.log(opt.data);
			let sendData = {};
			sendData["seq"] = opt.data.seq;
			sendData["status"] = st;

			pushInput.changePushStatus( {data:sendData, callback:function(json) {
				if(json) {
					alert(msgs);
					selfClose();
					opt.callback(true);
				}
				else {
					alert(msgf);
				}
			}});
	
		}
	}

	const goPage = (pageNum) => {
		reqList(pageNum);
	}

	const reqList = async (pg) => {
		Config.log(opt.data);
		let sendData = {};
		sendData["push_seq"] = opt.data.seq;
		sendData["status"] = "F";
		const resp =  pushStat.getLogList({data:sendData, callback:function(json) {
			setUserList(json.list);
			let items2 = CommonUI.pagenationItems({currPage:pg, totalRecords:json.count, eventHandler:goPage})
			setPageItems(items2);
		}});
		Config.log("getPushTargetList response=>");
		//resp.then( (data) => setUserList(data));
	}

	const retrySend = () => {
		if(window.confirm("발송 실패한 메시지를 재발송하시겠습니까?")) {
			if(opt.data.message_type == "ad") {
				if(check_reserve_time() == false) return;
			}
			Config.log(opt.data);
			let sendData = {};
			sendData["push_seq"] = opt.data.seq;
			sendData["status"] = "F";
			const resp =  pushInput.retryPushSend({data:sendData, callback:function(json) {
				if(json) {
					alert("푸시 재발송을 성공했습니다. \n 집계시점에 따라 성공건수와 실패건수의 차이가 있을 수 있습니다.");
					selfClose();
					opt.callback(true);
				}
				else {
					alert("재발송에 실패하였습니다. 다시시도해주세요.");
				}

			}});
	
		}
	}

	function check_reserve_time() {
		let rtn = true;
		let hour_v = getCurrentTime();
		if(hour_v >= "20:00" || hour_v <= "08:00") {
			rtn = false;
		}
		if(rtn == false) {
			alert('20:00 ~ 08:00 광고 발송 제한 시간입니다.');
		}
		return rtn;
	}

	function getCurrentTime() {
		const now = new Date();
		const hours = String(now.getHours()).padStart(2, '0'); // 시간
		const minutes = String(now.getMinutes()).padStart(2, '0'); // 분
		//const seconds = String(now.getSeconds()).padStart(2, '0'); // 초
	
		return `${hours}:${minutes}`;
	}

	const eventHandle = (ev: React.ChangeEvent<HTMLInputElement>) => {
		let evo = ev.currentTarget;
		let act_v = evo.getAttribute("data-act");
		console.log("act = " + act_v);
		if(act_v == "select") {
			var key = evo.getAttribute("data-index");
			Config.log("key=" + key);
			let uItem = userList[key];
			if(uItem.contentList) {
				let data = uItem.contentList;
				const user_ids = data.map(item => item.userId).join(', ');
				Config.log(user_ids);
				//opt.callback({list:user_ids, count:data.length});
				selfClose();
			}
		}
		else if(act_v == "close") {
			//isShow = false;
			selfClose();
		}
	};

	return (
		<Modal show={opt.isShow} onHide={selfClose} centered className="" size="sm">
			<Modal.Header closeButton>
			<Modal.Title>푸시 메시지</Modal.Title>
			</Modal.Header>
			<Modal.Body>
						<div className="text-center p-3">
							{opt.data.title}<br />
							<br />
							<strong>현재 상태 : {Config.getPushStatuName(opt.data.status)}</strong>
						</div>
					</Modal.Body>
			<Modal.Footer>
				{(() => {
					if(opt.data.status == "I" || opt.data.status == "R") {
						return <Col>
							<Button variant="secondary" onClick={() => changeStatus("E")}>긴급 종료</Button>
							<Button variant="primary ms-2" onClick={() => changeStatus("P")}>일시정지</Button>
						</Col>
					}
					else if(opt.data.status == "P") {
						return <Col>
							<Button variant="secondary" onClick={() => changeStatus("E")}>긴급 종료</Button>
							<Button variant="primary ms-2" onClick={() => changeStatus("R")}>일시정지 해제</Button>
						</Col>
					}
				})()}
				<Col className="text-end" xs={3}>
					<Button variant="secondary" onClick={() => selfClose()}>닫기</Button>
				</Col>
			
			</Modal.Footer>
		</Modal>

	);
};

export default PopupPushStatus;
